import { t } from '../../../common/i18n';
import { AdditionalFeaturesContent } from './AdditionalFeaturesContent.js';
import { getDefaultCardContentData } from './ProductOfferingCardContentUtils.js';
import type { ProductCardContentProps } from './types.js';

export const getMobileBroadbandCardContent = ({ productOffering }: ProductCardContentProps) => {
  const defaultData = getDefaultCardContentData(productOffering);

  return {
    subHeader: t.GHDJ('Business connection'),
    badges: defaultData.badges,
    infoItems: defaultData.infoItems,
    renderAdditionalContent: () => <AdditionalFeaturesContent additionalFeatures={defaultData.additionalFeatures} />,
  };
};
